export function exportToCSV<T>(
  data: T[],
  headers: string[],
  rowMapper: (item: T) => string[],
  filename: string
): void {
  if (data.length === 0) {
    console.warn('No data to export');
    return;
  }

  const rows = data.map(rowMapper);
  const csvContent = [headers, ...rows]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export function exportDashboardMetrics(stats: any[]): void {
  exportToCSV(
    stats,
    ['Metric', 'Value', 'Change'],
    (stat) => [stat.name, stat.value, stat.change],
    `dashboard-metrics-${new Date().toISOString().split('T')[0]}.csv`
  );
}
